import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "opportunityName", label: "Opportunity Name" },
	{ key: "organizationName", label: "Organization Name" },

	{ key: "probability", label: "Probability" },
	{ key: "bidAmount", label: "Bid Amount" },
	{ key: "bidType", label: "Bid Type" },
	{ key: "category", label: "Category" },
	{ key: "state", label: "State" },
	{ key: "location", label: "Location" },
	{ key: "actualCloseDate", label: "actual Close Date" },
	// { key: "projectId", label: "Project Id" },
	{ key: "contactIds", label: "Contacts" },
	{ key: "userResponsibleIds", label: "User Responsibles" },
	{ key: "background", label: "Background" },
	{ key: "void", label: "Void" }, 
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "creatorName", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterName", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];
export default function OpportunityExportForm(){
	return <ExportForm columns = {EXPORT_COLUMNS}/>;
}